import { gql } from "@apollo/client";


export const MoneyV2Fields = gql`
  fragment MoneyV2Fields on MoneyV2 {
    amount
    currencyCode
  }
`; 